import {
    APPBAR_HEIGHT,
    IconButton as UiIconButton,
    styled,
} from "@l2r-front/l2r-ui"

import { ADDITIONAL_SIDEBAR_WIDTH } from "../../../../common/constants/layout"

import { RoadsideTypeList as L2RRoadsideTypeList } from "../RoadsideTypeList"

export const SIDEBAR_SPACING = 8
export const SIDEBAR_SPACING_MOBILE = 4

export const Container = styled("div")(() => ({
}))

export const RoadsideTypeList = styled(L2RRoadsideTypeList)(({ theme }) => ({
    padding: theme.spacing(8),
}))

type AdditionalSidebarProps = {
    index: number,
}
export const AdditionalSidebar = styled("div", { shouldForwardProp: (prop) => prop !== "index" })<AdditionalSidebarProps>(({ index }) => ({
    height: `calc(100% - ${APPBAR_HEIGHT}px)`,
    position: "fixed",
    left: `calc(500px + ${index * ADDITIONAL_SIDEBAR_WIDTH}px)`,
    top: APPBAR_HEIGHT,
    width: ADDITIONAL_SIDEBAR_WIDTH,
    overflowY: "auto",
}))

export const TitleSideComponentWrapper = styled("div")({
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
})

export const IconButton = styled(UiIconButton)(() => ({
    marginLeft: "auto",
}))

export const RoadsideSidebarContainer = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 8, 6, 8),
}))